import { ImageDropZoneConstraints } from "@/shared/components/ImageDropZone";

// Per the ESR-1655 design. The backend allows more (homeTitle 120,
// homeSubtitle 200) - these are the limits that fit the customer app card.
export const HOME_TITLE_MAX_LENGTH = 25;
export const HOME_SUBTITLE_MAX_LENGTH = 45;

export const HOME_IMAGE_CONSTRAINTS: ImageDropZoneConstraints = {
  mimeTypes: ["image/jpeg", "image/png"],
  extensions: ["jpg", "jpeg", "png"],
  formatLabel: "JPG, JPEG or PNG",
  maxSizeMb: 5,
  minWidth: 1200,
  minHeight: 400,
  aspectRatio: 3,
  aspectRatioLabel: "3:1",
};

// Label for an image that's already saved - the API returns only its bytes,
// not the original filename.
export const SAVED_HOME_IMAGE_LABEL = "Current banner image";
